import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdLock, MdLogin, MdMessage, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdWhatsapp } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE_PHONE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INTRO_1,
  STR_INTRO_2,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_WELCOME
} from "../Strings";
import logo from "../assets/logo.png";
import logo_worded_only2 from "../assets/logo_worded_only2.png";
import logo_worded_only from "../assets/logo_worded_only.png";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("launch");

  async function init() {
    //..
  }

  async function getStarted() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }


  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  return (
    <div
      className="Login bg-background"
      style={{
        minHeight: "100vh",
        background: "radial-gradient(circle at 20% 10%, rgba(220, 38, 38, 0.12), transparent 40%), radial-gradient(circle at 90% 30%, rgba(31, 41, 51, 0.18), transparent 45%), linear-gradient(180deg, rgba(249, 250, 251, 1), rgba(243, 244, 246, 1))",
      }}
    >
      {
        (loginStep === 'launch') ?
          <div
            className="launch mNoScrollBar"
            style={{
              minHeight: "100vh",
            }}
          >

            <div className="container">

              <div className="row">


                <div
                  className="col-md-6 text-center"
                  style={{
                    position: "relative",
                  }}
                >

                  <div
                    className="text-center mMobileOnly"
                    style={{
                      paddingTop: "18px",
                    }}
                  >
                    <div
                      style={{
                        width: "86px",
                        height: "86px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "22px",
                        background: "rgba(255,255,255,0.75)",
                        boxShadow: "0px 20px 60px rgba(0,0,0,0.08)",
                        border: "1px solid rgba(31, 41, 51, 0.10)",
                        backdropFilter: "blur(8px)",
                      }}
                    >
                      <img
                        src={logo}
                        style={{
                          width: "58px",
                          height: "auto",
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="text-center mDesktopOnly"
                    style={{
                      paddingTop: "160px",
                      paddingBottom: "120px",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-block",
                        width: "100%",
                        maxWidth: "520px",
                        padding: "34px",
                        borderRadius: "28px",
                        background: "rgba(255,255,255,0.70)",
                        boxShadow: "0px 30px 90px rgba(0,0,0,0.10)",
                        border: "1px solid rgba(31, 41, 51, 0.10)",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "14px",
                          marginBottom: "18px",
                        }}
                      >
                        <div
                          style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "16px",
                            background: "rgba(220, 38, 38, 0.10)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgba(220, 38, 38, 0.20)",
                          }}
                        >
                          <img
                            src={logo}
                            style={{
                              width: "34px",
                              height: "auto",
                            }}
                          />
                        </div>

                        <div
                          style={{
                            textAlign: "left",
                          }}
                        >
                          <img
                            src={logo_worded_only2}
                            width="220px"
                            height="auto"
                            style={{
                              display: "block",
                            }}
                          />

                          <div
                            className="font-regular"
                            style={{
                              marginTop: "10px",
                              fontSize: "13px",
                              color: "#1F2933",
                              opacity: 0.80,
                            }}
                          >
                            Fast shopping • Great deals • Secure checkout
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                          marginTop: "26px",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px 12px",
                            borderRadius: "999px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(31, 41, 51, 0.10)",
                            boxShadow: "0px 10px 30px rgba(0,0,0,0.06)",
                            fontSize: "12px",
                            color: "#1F2933",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "999px",
                              background: "#DC2626",
                              display: "inline-block",
                            }}
                          />
                          New arrivals
                        </div>

                        <div
                          style={{
                            padding: "10px 12px",
                            borderRadius: "999px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(31, 41, 51, 0.10)",
                            boxShadow: "0px 10px 30px rgba(0,0,0,0.06)",
                            fontSize: "12px",
                            color: "#1F2933",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "999px",
                              background: "#1F2933",
                              display: "inline-block",
                            }}
                          />
                          Verified sellers
                        </div>

                        <div
                          style={{
                            padding: "10px 12px",
                            borderRadius: "999px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(31, 41, 51, 0.10)",
                            boxShadow: "0px 10px 30px rgba(0,0,0,0.06)",
                            fontSize: "12px",
                            color: "#1F2933",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span
                            style={{
                              width: "8px",
                              height: "8px",
                              borderRadius: "999px",
                              background: "#DC2626",
                              display: "inline-block",
                              opacity: 0.65
                            }}
                          />
                          Quick delivery
                        </div>
                      </div>

                    </div>
                  </div>

                </div>

                <div
                  className="col-md-6"
                  style={{
                    paddingTop: "140px"
                  }}
                >
                  <div className="text-center mMobileOnly">
                    <img
                      src={logo_worded_only2}
                      width="190px"
                      height="auto"
                      style={{
                        marginBottom: "28px"
                      }}
                    />

                    <div
                      className="font-regular"
                      style={{
                        fontSize: "13px",
                        color: "#1F2933",
                        opacity: 0.80,
                        marginBottom: "18px"
                      }}
                    >
                      Fast shopping • Great deals • Secure checkout
                    </div>
                  </div>

                  <div
                    className="card"
                    style={{
                      borderRadius: "22px",
                      border: "1px solid rgba(31, 41, 51, 0.10)",
                      overflow: "hidden",
                      boxShadow: "0px 24px 70px rgba(0,0,0,0.10)",
                      background: "rgba(255,255,255,0.75)",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    <div
                      style={{
                        height: "6px",
                        background: "linear-gradient(90deg, rgba(220, 38, 38, 1), rgba(31, 41, 51, 1))",
                      }}
                    />

                    <div className="card-body"
                      style={{
                        paddingTop: "30px",
                        paddingBottom: "26px",
                      }}
                    >

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          marginBottom: "14px",
                        }}
                      >
                        <div
                          style={{
                            width: "44px",
                            height: "44px",
                            borderRadius: "14px",
                            background: "rgba(220, 38, 38, 0.10)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgba(220, 38, 38, 0.16)",
                          }}
                        >
                          <MdLogin
                            size={22}
                            style={{
                              color: "#DC2626"
                            }}
                          />
                        </div>
                      </div>

                      <h6
                        style={{
                          fontSize: "20px",
                          lineHeight: "26px",
                          color: "#1F2933",
                        }}
                        className="font-regular mb-4 mt-2 text-center"
                      >
                        {STR_INTRO_2[appContext.language]}
                      </h6>

                      <div
                        className="text-center"
                        style={{
                          fontSize: "13px",
                          color: "#1F2933",
                          opacity: 0.75,
                          marginTop: "-8px",
                          marginBottom: "26px",
                        }}
                      >
                        Sign in to track orders, save items, and checkout faster
                      </div>

                      <div className="row" style={{ marginTop: "34px", marginBottom: "6px", }}>
                        <div className="col-6">
                          <button
                            className="btn btn-padded btn-block btn-primary btn-rounded"
                            style={{
                              textTransform: "capitalize",
                              fontSize: "14px",
                              backgroundColor: "#DC2626",
                              borderColor: "#DC2626",
                              boxShadow: "0px 14px 34px rgba(220, 38, 38, 0.22)",
                            }}
                            onClick={() => getStarted()}
                          >
                            {STR_GET_STARTED[appContext.language]}
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            className="btn btn-padded btn-block bg-background btn-rounded"
                            style={{
                              textTransform: "capitalize",
                              fontSize: "14px",
                              border: "1px solid rgba(31, 41, 51, 0.16)",
                              background: "rgba(255,255,255,0.70)",
                            }}
                            onClick={() => appContext.changeLanguage()}
                          >
                            {(appContext.language === 'en') ? "Use Swahili" : "Use English"}
                          </button>
                        </div>
                      </div>

                      <div
                        className="text-center"
                        style={{
                          marginTop: "18px",
                          fontSize: "12px",
                          color: "#1F2933",
                          opacity: 0.70,
                        }}
                      >
                        By continuing, you agree to our Terms & Privacy Policy
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
          : ""
      }


    </div >
  )
}
